import script from "./BaseRatingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRatingComponent.vue?vue&type=script&setup=true&lang=js"

import "./BaseRatingComponent.vue?vue&type=style&index=0&id=330fcad8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-330fcad8"]])

export default __exports__